import { render, staticRenderFns } from "./AuctionCategoryTermModal.vue?vue&type=template&id=34973924&scoped=true"
import script from "./AuctionCategoryTermModal.vue?vue&type=script&lang=js"
export * from "./AuctionCategoryTermModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34973924",
  null
  
)

export default component.exports